import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import "./xy-theme.css";

export default memo(({ data, isConnectable }) => {
  return (
    <div
      style={{
        width: "130px",
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        // onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />
      <div>{data.label || "Loop"} </div>

      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        id="right"
      />
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={isConnectable}
        id="bottom"
      />
    </div>
  );
});
